const rules = {
    cara_pengumpulan_data: { entri: 'required|min_value:1|max_value:4', kuesioner: 'required' },
    sektor_kegiatan: { entri: 'required|min_value:1|max_value:22', kuesioner: 'required' },
    kegiatan_ini_dilakukan: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    frekuensi_penyelanggara: { entri: 'required|min_value:1|max_value:8', kuesioner: 'required' },
    tipe_pengumpulan_data: { entri: 'required|min_value:1|max_value:3', kuesioner: 'required' },
    cakupan_wilayah_pengumpulan_data: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    metode_pengumpulan_data: { entri: 'required|min_value:1|max_value:31', kuesioner: 'required' },
    sarana_pengumpulan_data: { entri: 'required|min_value:1|max_value:63', kuesioner: 'required' },
    unit_pengumpulan_data: { entri: 'required|min_value:1|max_value:15', kuesioner: 'required' },
    jenis_rancangan_sampel: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    metode_pemilihan_sampel_terakhir: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    metode_yang_digunakan_probabilitas: { entri: 'required|min_value:1|max_value:5', kuesioner: 'required' },
    metode_yang_digunakan_nonprobabilitas: { entri: 'required|min_value:6|max_value:10', kuesioner: 'required' },
    kerangka_sampel_tahap_terakhir: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    apakah_melakukan_uji_coba: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    metode_pemeriksaan_kualitas_pengumpulan_data: { entri: 'required|min_value:1|max_value:15', kuesioner: 'required' },
    apakah_melakukan_penyesuaian_nonrespon: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    petugas_pengumpulan_data: { entri: 'required|min_value:1|max_value:3', kuesioner: 'required' },
    persyaratan_pendidikan_terendah_petugas_pengumpulan_data: { entri: 'required|min_value:1|max_value:4', kuesioner: 'required' },
    apakah_melakukan_pelatihan_petugas: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    editing: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    coding: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    entry: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    validasi: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    metode_analisis: { entri: 'required|min_value:1|max_value:3', kuesioner: 'required' },
    unit_analsis: { entri: 'required|min_value:1|max_value:15', kuesioner: 'required' },
    tingkat_penyajian_hasil_analisis: { entri: 'required|min_value:1|max_value:31', kuesioner: 'required' },
    tercetak: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    digital: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
    data_mikro: { entri: 'required|min_value:1|max_value:2', kuesioner: 'required' },
};

export const judulKegiatanRules = {
  required: true,
  regex: /^(Pendataan|Pencacahan|Kompilasi|Sensus|Survei|Pengumpulan)(\s|$)/
};

export default rules;